import React, { useEffect, useState } from "react";
import { StarFilled, CheckOutlined } from "@ant-design/icons";
import { Card, Row, Col, Typography, Button } from "antd";
import ProfileImg from "./../../assets/Profile.jpg";
import axiosPublic from "./../../store/api/axiosPublic";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

function PriorityLeadCard({ onTopPickClick, name, place, rating, onBuyNow }) {
  // const [loading, setLoading] = useState(false);
  // const [lead, setLead] = useState(null);
  const [leads, setLeads] = useState([]);
  const navigate = useNavigate();

  const currentUserId = localStorage.getItem("id");

  useEffect(() => {
    fetchPriorityLeads();
  }, []);

  const fetchPriorityLeads = async () => {
    try {
      const res = await axiosPublic.get(
        "https://apilead.blaccdot.ae/api/admin/top-leads/",
      );

      if (res.data?.success) {
        setLeads(res.data.data.slice(0, 2));
      }
    } catch (error) {
      console.error("Error fetching priority leads:", error);
    }
  };

  if (!leads.length) return null;

  const isBoughtByUser = leads.boughtBy?.some(
    (b) => b.userId === currentUserId,
  );
  const isBought = isBoughtByUser;

  return (
    <>
      {leads.map((lead) => {
        const isBought = lead.boughtBy?.some((b) => b.userId === currentUserId);

        return (
          <Card
            key={lead._id}
            style={{
              borderRadius: 6,
              background: "#fff",
              border: "1px solid #98c3ffff",
              marginBottom: 12,
            }}
          >
            {/* Image + Name */}
            <Row gutter={12} align="middle">
              <Col flex="40px">
                <img
                  src={ProfileImg}
                  alt={lead.name}
                  style={{ width: 40, height: 40, borderRadius: "50%" }}
                />
              </Col>

              <Col flex="auto">
                <Text strong style={{ fontSize: 14 }}>
                  {lead.name}
                </Text>
                <br />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {lead.location}
                </Text>
              </Col>
            </Row>

            {/* Rating + underline */}
            <Row style={{ marginTop: 12 }}>
              <Col span={24}>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {lead.timesBought}/{lead.leadAvailableCount} buyers buy this
                  lead
                </Text>

                {/* Progress line */}
                <div style={{ position: "relative", marginTop: 8, height: 14 }}>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: 0,
                      right: 0,
                      height: 2,
                      background: "#d9d9d9",
                      transform: "translateY(-50%)",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: 0,
                      width: 130,
                      height: 2,
                      background: "#1677ff",
                      transform: "translateY(-50%)",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: 130,
                      width: 10,
                      height: 10,
                      background: "#1677ff",
                      transform: "translate(-50%, -50%)",
                      borderRadius: 2,
                    }}
                  />
                </div>

                {/* <Button
                  type="primary"
                  block
                  disabled={isBought}
                  style={{              
                   
                    marginTop: 12,
                    cursor: "pointer",
                  }}
                  icon={<StarFilled style={{ color: "#FADB14" }} />}
                  onClick={() => onTopPickClick(lead._id)}
                >
                  {isBought ? "Bought ✓" : "Top Pick"}
                </Button> */}

                <Button
                  type="primary"
                  block
                  disabled={isBought}
                  icon={
                    isBought ? (
                      <CheckOutlined />
                    ) : (
                      <StarFilled style={{ color: "#FADB14" }} />
                    )
                  }
                  style={{
                    marginTop: 12,
                    backgroundColor: isBought ? "#f6ffed" : undefined, // light green
                    borderColor: isBought ? "#b7eb8f" : undefined,
                    color: isBought ? "#389e0d" : undefined,
                    cursor: isBought ? "default" : "pointer",
                  }}
                  onClick={() => onTopPickClick(lead._id)}
                >
                  {isBought ? "Bought" : "Top Pick"}
                </Button>
              </Col>
            </Row>
          </Card>
        );
      })}
    </>
  );
}

export default PriorityLeadCard;
